import React from 'react';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { CardContainer, Header, BlockHeader } from './styled';
import CardLogo from '../CardLogo';
import { CARD_ANNOUNCEMENT_ID, CardTypes } from '../../constants/PaymentTypes';
import { CardAnnouncement } from './styled';
import { getString } from '../../constants/Strings';
import { getPaymentFieldLabelText } from './helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { paymentSelector } from '../../redux/PaymentState/PaymentState.selectors';
var FormHeader = function FormHeader(props) {
  var config = useAppSelector(configSelector);
  var paymentForm = config.paymentForm;
  var payment = useAppSelector(paymentSelector);
  var matchedCards = payment.matchedCards;
  var isEdit = props.isEdit;
  function cardInstruction() {
    if (!(matchedCards[CardTypes.VISA] && matchedCards[CardTypes.AMERICANEXPRESS] && matchedCards[CardTypes.MASTERCARD] && matchedCards[CardTypes.DISCOVER])) {
      var cardType = '';
      if (matchedCards[CardTypes.VISA]) cardType = CardTypes.VISA;else if (matchedCards[CardTypes.AMERICANEXPRESS]) {
        cardType = CardTypes.AMERICANEXPRESS;
      } else if (matchedCards[CardTypes.MASTERCARD]) {
        cardType = CardTypes.MASTERCARD;
      } else if (matchedCards[CardTypes.DISCOVER]) {
        cardType = CardTypes.DISCOVER;
      } else cardType = 'no card';
      return /*#__PURE__*/React.createElement(CardAnnouncement, {
        id: CARD_ANNOUNCEMENT_ID,
        "data-test": 'CardAnnouncement',
        "aria-live": 'polite'
      }, "".concat(cardType, " is selected"));
    } else {
      return;
    }
  }
  return /*#__PURE__*/React.createElement(Header, {
    "data-test": DataTestAttributes.CREDIT_CARD_FORM_HEADER
  }, /*#__PURE__*/React.createElement(CardContainer, null, /*#__PURE__*/React.createElement("div", {
    id: 'pm-payment-form-header'
  }, /*#__PURE__*/React.createElement(BlockHeader, null, /*#__PURE__*/React.createElement("span", null, isEdit ? getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.EDIT_CARD) || getString('APP.FORM.HEADER.EDIT') : getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.PAY_WITH_CARD) || getString('APP.FORM.HEADER.PAY')))), !isEdit && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CardLogo, {
    dataTest: DataTestAttributes.VISA_CARD,
    cardType: CardTypes.VISA,
    valid: !!matchedCards[CardTypes.VISA],
    isMopContainer: false
  }), /*#__PURE__*/React.createElement(CardLogo, {
    dataTest: DataTestAttributes.AMERICAN_EXPRESS_CARD,
    cardType: CardTypes.AMERICANEXPRESS,
    valid: !!matchedCards[CardTypes.AMERICANEXPRESS],
    isMopContainer: false
  }), /*#__PURE__*/React.createElement(CardLogo, {
    dataTest: DataTestAttributes.MASTER_CARD,
    cardType: CardTypes.MASTERCARD,
    valid: !!matchedCards[CardTypes.MASTERCARD],
    isMopContainer: false
  }), /*#__PURE__*/React.createElement(CardLogo, {
    dataTest: DataTestAttributes.DISCOVER_CARD,
    cardType: CardTypes.DISCOVER,
    valid: !!matchedCards[CardTypes.DISCOVER],
    isMopContainer: false
  }), cardInstruction())));
};
export default FormHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentForm/FormHeader.js
// module id = 1498
// module chunks = 11